namespace TabAurous.OMS {
    export interface CompanyRow {
        CompanyId?: number;
        CompanyName?: string;
        CompanyCode?: string;
        MailingName?: string;
        Address?: string;
        Address2?: string;
        Phone?: string;
        Mobile?: string;
        EmailId?: string;
        Web?: string;
        City?: string;
        CityName?: string;
        Country?: string;
        CountryName?: string;
        State?: string;
        StateName?: string;
        Pin?: string;
        CurrencyId?: number;
        TaxGroupId?: number;
        LedgerId?: number;
        TIN?: string;
        CST?: string;
        PAN?: string;
        CurrentDate?: string;
        Logo?: string;
        CodeandName?: string;
        TypeOfCompany?: string;
        ParentCompany?: string;
        IsDefault?: boolean;
        IsDisabled?: boolean;
        IsPriceList?: boolean;
        IsLabourList?: boolean;
        PPriceListId?: number;
        PLabourListId?: number;
        SPriceListId?: number;
        SLabourListId?: number;
        DiscountingPolicyId?: number;
        MarkUpPolicyId?: number;
        PMarkup?: number;
        PLMarkup?: number;
        SMarkup?: number;
        SLMarkup?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace CompanyRow {
        export const idProperty = 'CompanyId';
        export const nameProperty = 'CompanyName';
        export const localTextPrefix = 'OMS.Company';
        export const lookupKey = 'OMS.Company';

        export function getLookup(): Q.Lookup<CompanyRow> {
            return Q.getLookup<CompanyRow>('OMS.Company');
        }
        export const deletePermission = 'Company:Delete';
        export const insertPermission = 'Company:Add';
        export const readPermission = '*';
        export const updatePermission = 'Company:Edit';

        export declare const enum Fields {
            CompanyId = "CompanyId",
            CompanyName = "CompanyName",
            CompanyCode = "CompanyCode",
            MailingName = "MailingName",
            Address = "Address",
            Address2 = "Address2",
            Phone = "Phone",
            Mobile = "Mobile",
            EmailId = "EmailId",
            Web = "Web",
            City = "City",
            CityName = "CityName",
            Country = "Country",
            CountryName = "CountryName",
            State = "State",
            StateName = "StateName",
            Pin = "Pin",
            CurrencyId = "CurrencyId",
            TaxGroupId = "TaxGroupId",
            LedgerId = "LedgerId",
            TIN = "TIN",
            CST = "CST",
            PAN = "PAN",
            CurrentDate = "CurrentDate",
            Logo = "Logo",
            CodeandName = "CodeandName",
            TypeOfCompany = "TypeOfCompany",
            ParentCompany = "ParentCompany",
            IsDefault = "IsDefault",
            IsDisabled = "IsDisabled",
            IsPriceList = "IsPriceList",
            IsLabourList = "IsLabourList",
            PPriceListId = "PPriceListId",
            PLabourListId = "PLabourListId",
            SPriceListId = "SPriceListId",
            SLabourListId = "SLabourListId",
            DiscountingPolicyId = "DiscountingPolicyId",
            MarkUpPolicyId = "MarkUpPolicyId",
            PMarkup = "PMarkup",
            PLMarkup = "PLMarkup",
            SMarkup = "SMarkup",
            SLMarkup = "SLMarkup",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
